import axios from '@/libs/api.request';

export const getYSLogList = data => {
    return axios.request({
        url: '/api/ysLog/getYSLogList',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const ysTransferApplySync = data => {
    return axios.request({
        url: '/api/ysManagement/ysTransferApplySync',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const ysTransferApplyDel = data => {
    return axios.request({
        url: '/api/ysManagement/ysTransferApplyDel',
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
